import React from 'react';
import ApplicationForm from '../components/ApplicationForm';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const CoursePageTemplate = ({ title, description, icon }) => {
  const [showApplicationModal, setShowApplicationModal] = React.useState(false);

  return (
    <>
      <div className="container mt-5 pt-5">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="text-center mb-5">{title}</h1>
            
            <div className="row gy-4">
              <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                <img src={icon || "/assets/img/civil-icon.png"} className="img-fluid mb-4" alt={title} />
              </div>
              <div className="col-lg-6" data-aos="fade-up" data-aos-delay="250">
                <div className="content ps-0 ps-lg-5">
                  <h3>About {title}</h3>
                  <p className="fst-italic">
                    {description}
                  </p>
                  
                  <div className="program-details mt-4">
                    <h5>Program Highlights:</h5>
                    <ul>
                      <li><i className="bi bi-check-circle-fill"></i> <span>Duration: 3 Years (Flexible Shift Timings)</span></li>
                      <li><i className="bi bi-check-circle-fill"></i> <span>Approved by UGC & AICTE</span></li>
                      <li><i className="bi bi-check-circle-fill"></i> <span>Eligibility: Polytechnic Diploma / B.Sc / B.Voc (Min 1 year experience)</span></li>
                      <li><i className="bi bi-check-circle-fill"></i> <span>Industry-relevant curriculum</span></li>
                      <li><i className="bi bi-check-circle-fill"></i> <span>Practical hands-on training</span></li>
                      <li><i className="bi bi-check-circle-fill"></i> <span>Placement assistance</span></li>
                    </ul>
                  </div>
                  
                  <div className="mt-4">
                    <button 
                      className="btn btn-primary btn-lg"
                      onClick={() => setShowApplicationModal(true)}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

// B.Tech Pages
export const BTechComputerScienceEngineering = () => (
  <CoursePageTemplate 
    title="B.Tech Computer Science Engineering (Lateral Entry)"
    description="Our B.Tech Computer Science Engineering program is designed for working professionals who want to advance their careers in software development, system design, and computer applications. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const BTechElectricalEngineering = () => (
  <CoursePageTemplate 
    title="B.Tech Electrical Engineering (Lateral Entry)"
    description="Our B.Tech Electrical Engineering program is designed for working professionals who want to advance their careers in electrical systems, power generation, and electrical design. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const BTechElectronicAndCommunicationEngineering = () => (
  <CoursePageTemplate 
    title="B.Tech Electronic & Communication Engineering (Lateral Entry)"
    description="Our B.Tech Electronic & Communication Engineering program is designed for working professionals who want to advance their careers in electronics, telecommunications, and communication systems. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const BTechChemicalEngineering = () => (
  <CoursePageTemplate 
    title="B.Tech Chemical Engineering (Lateral Entry)"
    description="Our B.Tech Chemical Engineering program is designed for working professionals who want to advance their careers in chemical processes, manufacturing, and process design. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const BTechMechanicalEngineering = () => (
  <CoursePageTemplate 
    title="B.Tech Mechanical Engineering (Lateral Entry)"
    description="Our B.Tech Mechanical Engineering program is designed for working professionals who want to advance their careers in mechanical design, manufacturing, and mechanical systems. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const BTechCivilEngineering = () => {
  const [showApplicationModal, setShowApplicationModal] = React.useState(false);

  return (
    <>
      {/* Page Title Banner */}
      <div className="breadcrumbbg page-title aos-init aos-animate" data-aos="fade">
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <h1 className="">B.Tech In Civil Engineering</h1>
              <p className="fs-5 text-danger"><strong>Lateral Entry Program </strong></p>
              <p>Advance your career with our 3-year undergraduate program, designed for diploma holders and working professionals who need flexible learning schedules</p>
            </div>
          </div>
        </div>
      </div>

      {/* Course Overview Section */}
      <section id="overview" className="overview section">
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-8">
              <div className="border rounded overflow-hidden">
                <h2 className="fw-bold bg-primary bg-opacity-10 textprimary p-2 px-lg-3">Course Overview</h2>
                <div className="p-2 p-lg-3">
                  <p>B.Tech Civil Engineering (Lateral Entry) at Mewar University is a 3-year undergraduate program exclusively for polytechnic diploma holders. This program allows students to join directly in the second year, saving both time and resources while acquiring advanced, industry-focused knowledge and skills.</p>
                  
                  <p>Mewar University, a leading institution in Chittorgarh, Rajasthan, offers this course with flexible shift timings, making it an ideal choice for working professionals who wish to balance their job and studies. The curriculum combines theoretical learning with hands-on exposure through labs, field visits, industrial training, internships, and live projects, ensuring students are industry-ready.</p>
                  
                  <p>Graduates of this program can build careers as Site Engineers, Project Managers, Structural Designers, Urban Planners, or Government Engineers in organisations like PWD, CPWD, and NHAI. They also have the option to pursue higher studies such as M.Tech or MBA.</p>
                  
                  <p>Conducted in a blended mode, the program delivers theory both online and offline, while practical and laboratory sessions are held on campus—providing the perfect balance of flexibility, quality, and career growth.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="shadow-sm rounded border overflow-hidden mb-4">
                <h5 className="bg-primary bg-opacity-10 textprimary fw-bold p-2 p-lg-3">Quick Facts</h5>
                <div className="px-3 px-lg-4">
                  <div className="sidebar-form">
                    <div className="heading text-center">
                      <p className="mb-1">APPLY TODAY FOR</p>
                      <h3 className="fs-5 text-danger">Mewar University Programs</h3>
                    </div>
                    <form className="mt-3">
                      <div className="mb-3">
                        <input 
                          type="text" 
                          className="form-control" 
                          placeholder="Your Name" 
                          required 
                        />
                      </div>
                      <div className="mb-3">
                        <input 
                          type="email" 
                          className="form-control" 
                          placeholder="Your Email" 
                          required 
                        />
                      </div>
                      <div className="mb-3">
                        <input 
                          type="tel" 
                          className="form-control" 
                          placeholder="Your Phone" 
                          required 
                        />
                      </div>
                      <div className="mb-3">
                        <select className="form-select" required>
                          <option value="" disabled>Select Course</option>
                          <option value="B-Tech-Civil-Engineering">B.Tech Civil Engineering</option>
                        </select>
                      </div>
                      <div className="text-center">
                        <button 
                          type="button"
                          className="btn btn-danger btn-lg w-100"
                          onClick={() => setShowApplicationModal(true)}
                        >
                          Apply Now
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Program Highlights Section */}
      <section id="programht" className="programht section blue-bg">
        <div className="container section-title" data-aos="fade-up" data-aos-delay="200">
          <p><span>Program </span> <span className="description-title">Highlights</span></p>
        </div>
        <div className="container" data-aos="fade-in" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-book-half"></i>
                  </div>
                  <h5 className="fw-bold w-75">A Program for Specialized Civil Engineering</h5>
                </div>
                Specifically tailored for polytechnic diploma holders, Mewar University's 3-year B.Tech Lateral Entry program in Civil Engineering helps students strengthen both their credentials and technical proficiency.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-hourglass-top"></i>
                  </div>
                  <h5 className="fw-bold w-75">Adaptable for Working Professionals</h5>
                </div>
                Designed with working professionals in mind, the program offers adaptable schedules that allow learners to upskill without interrupting their jobs.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-bookmark-star-fill"></i>
                  </div>
                  <h5 className="fw-bold w-75">Approved and Recognized by UGC/AICTE</h5>
                </div>
                The UGC and AICTE have recognized the Mewar University's B.Tech Lateral Entry programs, guaranteeing national recognition and eligibility for competitive tests like GATE and other government exams.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-person-rolodex"></i>
                  </div>
                  <h5 className="fw-bold w-75">Comprehensive Career Advancement</h5>
                </div>
                MEWAR University offers comprehensive professional development that goes beyond conventional teaching techniques. Through frequent industry expert guest lectures, live projects, and industry visits, the institution makes sure that students get both technical know-how and firsthand experience with real-world business situations.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-pc-display-horizontal"></i>
                  </div>
                  <h5 className="fw-bold w-75">Flexible Class Schedules & Round-the-Clock Access</h5>
                </div>
                Classes are offered in flexible time shifts on weekends, holidays, and weekdays (in the evening, after work hours). Once lessons are over, the Learning Management System (LMS) makes recorded lectures available around-the-clock.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-award"></i>
                  </div>
                  <h5 className="fw-bold w-75">Higher Levels of Experience Based Learning</h5>
                </div>
                A variety of experiential learning components are used in the program's experiments, including virtual labs, remote labs, and simulations. These components include industry-leading software tools, programming languages, and simulation software to create an on-campus experience.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-journal-medical"></i>
                  </div>
                  <h5 className="fw-bold w-75">All-inclusive Assessment Framework</h5>
                </div>
                Every semester, there are midterm and final exams for every course, which are often scheduled for the weekends. According to the semester's course schedule, online tests and assignments are also given.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-bullseye"></i>
                  </div>
                  <h5 className="fw-bold w-75">Various Professional Paths</h5>
                </div>
                Site Engineer, Structural Designer, Project Manager, Highway Engineer, and other positions are among the career options open to graduates of the B.Tech Lateral Entry Civil Engineering program. Additionally, they are able to apply for government positions.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Course Section */}
      <section id="explore-crs" className="explore-crs section bg-light">
        <div className="container section-title" data-aos="fade-up">
          <p><span>Explore </span> <span className="description-title"> Our Course</span></p>
        </div>
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-tabs d-flex aos-init aos-animate" data-aos="fade-up" data-aos-delay="100" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link show active" href="#pills-eligibility" data-bs-toggle="tab" data-bs-target="#pills-eligibility" aria-selected="true" role="tab">
                    <h4>Eligibility Criteria</h4>
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#pills-pro-duration" data-bs-toggle="tab" data-bs-target="#pills-pro-duration" aria-selected="false" role="tab" tabIndex="-1">
                    <h4>Program Duration</h4>
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#pills-fee-structure" data-bs-toggle="tab" data-bs-target="#pills-fee-structure" aria-selected="false" role="tab" tabIndex="-1">
                    <h4>Fee Structure</h4>
                  </a>
                </li>
              </ul>

              <div className="tab-content bg-white border rounded-3 p-3 p-lg-4 shadow-sm" id="pills-tabContent">
                <div className="tab-pane fade active show" id="pills-eligibility" role="tabpanel" aria-labelledby="pills-eligibility-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Eligibility Criteria
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <div className="qualification">
                    <h6 className="fw-600 mb-3">Qualification</h6>
                    <ol>
                      <li className="mb-2">To be eligible to apply, the candidate must have completed a 3-year polytechnic diploma in the relevant subject.</li>
                      <li className="mb-2">Candidate must have at least 1 year of work experience in any relevant job in registered companies, industries, institutions, educational or government organizations.</li>
                      <li className="mb-2">Professionals with experience in finding full potential in key sectors.</li>
                    </ol>
                  </div>
                  <div className="age-criteria">
                    <h6 className="fw-600 mb-3">Age Criteria</h6>
                    <ol>
                      <li className="mb-2">There is no age restriction for those who want to pursue this course.</li>
                      <li className="mb-2">People who want to advance their career by understanding the technical and basic principles well should apply for this course.</li>
                    </ol>
                  </div>
                </div>

                <div className="tab-pane fade" id="pills-pro-duration" role="tabpanel" aria-labelledby="pills-pro-duration-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Program Duration
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <ol>
                    <li className="mb-2">The program lasts a total of 3 years and is divided into 6 academic semester terms in lateral entry mode.</li>
                    <li className="mb-2">The final semester is for Project Work, VIVA, and Industrial Training.</li>
                    <li className="mb-2">The course includes theoretical lectures and virtual laboratories where the experiment is conducted remotely using simulations.</li>
                  </ol>
                </div>

                <div className="tab-pane fade" id="pills-fee-structure" role="tabpanel" aria-labelledby="pills-fee-structure-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Fee Structure
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Course Fee (Per Semester) - ₹ 50,000</h6>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Exam Fee (Per Semester) - ₹ 2500</h6>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Registration Fee (One Time) - ₹ 5000</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section id="why-us" className="why-us section light-background">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="why-box">
                <h3>Specialized Programs</h3>
                <p>
                  Mewar University's Specialized Programs combine academic excellence with industry-focused training. They prepare students with practical skills and knowledge to excel in their chosen careers.
                </p>
              </div>
            </div>
            <div className="col-lg-8 d-flex align-items-stretch">
              <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />
            </div>
          </div>
        </div>
      </section>

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export const BTechMiningEngineering = () => (
  <CoursePageTemplate 
    title="B.Tech Mining Engineering (Lateral Entry)"
    description="Our B.Tech Mining Engineering program is designed for working professionals who want to advance their careers in mining operations, mineral processing, and mining technology. This flexible program allows you to continue working while pursuing your degree."
  />
);

// M.Tech Pages
export const MTechCivilEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Civil Engineering"
    description="Our M.Tech Civil Engineering program is designed for working professionals who want to advance their careers in advanced civil engineering concepts, research, and specialized areas of civil engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const MTechComputerScienceEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Computer Science & Engineering"
    description="Our M.Tech Computer Science & Engineering program is designed for working professionals who want to advance their careers in advanced computer science concepts, research, and specialized areas of computer engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const MTechElectricalEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Electrical Engineering"
    description="Our M.Tech Electrical Engineering program is designed for working professionals who want to advance their careers in advanced electrical engineering concepts, research, and specialized areas of electrical engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const MTechElectronicsCommunicationEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Electronics & Communication Engineering"
    description="Our M.Tech Electronics & Communication Engineering program is designed for working professionals who want to advance their careers in advanced electronics and communication concepts, research, and specialized areas of electronics engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const MTechChemicalEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Chemical Engineering"
    description="Our M.Tech Chemical Engineering program is designed for working professionals who want to advance their careers in advanced chemical engineering concepts, research, and specialized areas of chemical engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const MTechMechanicalEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Mechanical Engineering"
    description="Our M.Tech Mechanical Engineering program is designed for working professionals who want to advance their careers in advanced mechanical engineering concepts, research, and specialized areas of mechanical engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const MTechMiningEngineering = () => (
  <CoursePageTemplate 
    title="M.Tech Mining Engineering"
    description="Our M.Tech Mining Engineering program is designed for working professionals who want to advance their careers in advanced mining engineering concepts, research, and specialized areas of mining engineering. This flexible program allows you to continue working while pursuing your degree."
  />
);

export const RecognitionsAchievements = () => {
  return (
    <div className="container mt-5 pt-5">
      <div className="row">
        <div className="col-lg-12">
          <h1 className="text-center mb-5">Recognitions & Achievements</h1>
          
          <div className="row gy-4">
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <img src="/assets/img/awards/NAAC_finalacc.jpg" className="img-fluid mb-3" alt="NAAC Accreditation" />
                  <h5 className="card-title">NAAC Accreditation</h5>
                  <p className="card-text">Grade 'A' accreditation by NAAC</p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <img src="/assets/img/awards/NIRF 2023.png" className="img-fluid mb-3" alt="NIRF Ranking" />
                  <h5 className="card-title">NIRF Ranking</h5>
                  <p className="card-text">Recognized in NIRF rankings 2023</p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <img src="/assets/img/awards/UGC-Approved.jpg" className="img-fluid mb-3" alt="UGC Approved" />
                  <h5 className="card-title">UGC Approved</h5>
                  <p className="card-text">Recognized by UGC under sections 2(f) and 22(1)</p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <img src="/assets/img/awards/AICTE-Approved.jpg" className="img-fluid mb-3" alt="AICTE Approved" />
                  <h5 className="card-title">AICTE Approved</h5>
                  <p className="card-text">All programs approved by AICTE</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
